import { render, staticRenderFns } from "./AboutMePage.vue?vue&type=template&id=1eba6fd8&scoped=true&"
import script from "./AboutMePage.vue?vue&type=script&lang=js&"
export * from "./AboutMePage.vue?vue&type=script&lang=js&"
import style0 from "./AboutMePage.vue?vue&type=style&index=0&id=1eba6fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eba6fd8",
  null
  
)

export default component.exports